import { ThemeUICSSObject, responsive, spacing } from '@apia/theme';
/* IMPORT HERE */

const documentUpload: ThemeUICSSObject = {
  variant: 'layout.common.modals.confirm',

  width: responsive({ 0: 'auto', 4: '750px' }),
  maxWidth: 'calc(100vw - 30px)',
  display: 'grid',
  gap: spacing(4),
  pb: spacing(2),
  px: 0,

  '.confirm__content': {
    px: 3,
    overflow: 'auto',
  },

  '.documentUploadModal__main': {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(4),

    '& > section': {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(4),

      '& > .collapsiblePanel': {
        '& > .collapsiblePanel__content': {
          border: '1px solid',
          borderColor: 'palette.border.section',
          transition: 'border 0.3s',

          '&[aria-hidden="true"]': {
            border: 'none',
          },

          '& > div': {
            p: spacing(4),
          },
        },
        /* '&.permissionspanel': {
          '& > .collapsiblePanel__content': {
            '& > div': {
              p: spacing(0),
              pt: spacing(4),
              pl: spacing(4),
              pb: spacing(4),
            },
          },
        }, */
      },
    },
  },

  '.stickyHeader': {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(4),
    position: 'sticky',
    top: 0,
    zIndex: 1,
    backgroundColor: 'palette.background.paper',

    '& label': {
      alignItems: 'stretch',
    },

    '.docTypes__combo__wrapper': {
      display: 'flex',
      alignItems: 'center',
      gap: spacing(3),

      '.iconButton': {
        height: '49px', // Lamentablemente, no pude encontrar otra solución que funcione en firefox
        width: '45px',
      },

      '& > div:first-of-type': {
        flexGrow: 100,
      },

      '.docTypes__info': {
        svg: {
          flexShrink: 0,
          width: '25px',
          height: '25px',
          cursor: 'pointer',
          color: 'primary',
        },

        ':hover': {
          svg: {
            color: (theme) =>
              theme.palette.lightenColor(theme.palette.primary.main, 10),
          },
        },
      },
    },
  },

  '.uploaderModal__dropzone__wrapper': {
    display: 'flex',
    flexDirection: responsive({ 0: 'column', 3: 'row' }),
    gap: spacing(4),
  },

  '.dropzone': { width: '100%', height: '100%' },

  '.uploaderModal__dropzone__buttons': {
    flexShrink: '1',
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(3),
  },

  '.uploaderModal__dropzone': {
    display: 'flex',
    flexBasis: '100%',
    flexDirection: 'column',
    flexGrow: '1000',
  },

  '.pickFromDirectories, .pickFromDocuments': {
    variant: 'buttons.outline',
    flexShrink: 0,
    borderWidth: '1px',
  },

  'label.fieldWrapper span, .collapsiblePanel__label__button, .collapsiblePanel__label':
    {
      fontSize: 18,
      fontWeight: 'bold',
    },

  '.documentUpload__generaData': {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(3),
    alignItems: 'start',

    '& label': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start',
      width: '100%',
    },
  },

  '.metadata__wrapper': {
    overflow: 'auto',
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: spacing(4),

    '.selection__keyHandler, .NoMetadataLabel': {
      height: '40vh',
      overflow: 'auto',
    },

    '.metadata__actions': {
      display: 'flex',
      justifyContent: 'end',
      gap: spacing(3),
    },

    '.metadataField__wrapper': {
      '.metadataField': {
        display: 'flex',
        gap: spacing(2),

        '& > *': {
          width: '100%',
        },
      },
    },

    '.fieldLabel__container': {
      width: '100%',
    },
  },

  '.directoriespanel': {
    '.directories__content': {
      maxHeight: '25vh',
      overflow: 'auto',
    },
  },

  '.currentFilespanel': {
    '.filesList': {
      minHeight: '1em',
      maxHeight: '25vh',
      overflow: 'auto',
      mt: spacing(4),
    },
  },

  '.permissionspanel': {
    '.collapsiblePanel__content > div': {
      pr: spacing(0),
    },
    '.permissions': {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(4),
      maxHeight: '60vh',
      overflow: 'auto',
      pr: spacing(4),
      position: 'relative',

      '.permissions__header': {
        alignItems: 'center',
        background: 'palette.background.paper',
        display: 'flex',
        flexWrap: 'wrap',
        gap: spacing(3),
        top: 0,

        '& label': {
          variant: 'layout.common.boxes.selectBox',
          flexShrink: 0,
          flexGrow: 1,
          justifyContent: 'stretch',

          '& > *': {
            flexGrow: 1,
          },
        },

        '.permissionsAddButtons': {
          display: 'flex',
          gap: spacing(3),
          flexDirection: responsive({ 0: 'column', 3: 'row' }),
        },
      },

      '.permissions__list': {
        display: 'flex',
        flexDirection: 'column',
        gap: spacing(3),

        h4: {
          fontSize: 16,
          m: spacing(0),
          mt: responsive({ 0: 4, 4: 0 }),
        },

        ul: {
          listStyle: 'none',
          p: spacing(0),
          display: 'flex',
          flexDirection: 'column',
          gap: spacing(2),
        },
      },
    },
  },
  /* PREPEND HERE */
};

export default documentUpload;
